import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Row, Col, Flex, Space } from 'antd';
import { textStyle } from './styles';
import { ImageTheme } from '../../../components/images';
import { ButtonTheme } from './components/buttons';
import logo from '../../../assets/images/logo-focus.png';
import { useGetPolicies } from './hooks/useGetPolicies';

export const TermWarranty = () => {
  let history = useHistory();
  const { data: policies } = useGetPolicies();
  function onClose() {
    history.goBack();
  }

  return (
    <div style={{ width: '100vw', height: '100%', overflowY: 'auto' }}>
      <Row>
        <Col span={24}>
          <Space direction="vertical" align="center" style={{ width: '100%', marginTop: 20 }}>
            <ImageTheme src={logo} style={{ width: 200 }} />
          </Space>
        </Col>
      </Row>
      <Space direction="vertical" size={16} style={{ width: '100%', padding: '0 40px' }}>
        <Row>
          <Col span={24}>
            <Typography.Text
              strong
              style={textStyle.textTitle}
            >{`การรับประกันสินค้าฟิล์มและกระจกกันรอย Focus เงื่อนไขการรับประกันสินค้า`}</Typography.Text>
          </Col>
        </Row>
        <Flex vertical justify="center" style={{ width: '100%' }}>
          {policies ? (
            <div style={textStyle.textContent}>
              {typeof policies === 'string' ? ( //string
                policies.split('\r\n').map((line, index) => (
                  <p key={index} style={{ margin: line.trim() === '' ? '10px 0' : '5px 0' }}>
                    {/^\d+\./.test(line) ? (
                      <span style={{ paddingLeft: '20px', display: 'block' }}>{line}</span>
                    ) : (
                      line
                    )}
                  </p>
                ))
              ) : policies.policyText ? (
                policies.policyText.split('\r\n').map(
                  (
                    line,
                    index, //object
                  ) => (
                    <p key={index} style={{ margin: line.trim() === '' ? '10px 0' : '5px 0' }}>
                      {/^\d+\./.test(line) ? (
                        <span style={{ paddingLeft: '20px', display: 'block' }}>{line}</span>
                      ) : (
                        line
                      )}
                    </p>
                  ),
                )
              ) : (
                <pre>{JSON.stringify(policies, null, 2)}</pre>
              )}
            </div>
          ) : (
            <p>กำลังโหลดข้อมูล...</p>
          )}
        </Flex>

        <Flex justify="center" style={{ width: '100%', marginTop: '15px' }}>
          <ButtonTheme useFor="BACK" title="กลับ" onClick={onClose} />
        </Flex>
      </Space>
    </div>
  );
};
